import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleProtectedRoute = ({ element, requiredRoles }) => {
  const { isAuthenticated, userRole } = useAuth();
  const location = useLocation();
  const [alertShown, setAlertShown] = useState(false);

  console.log('[RoleProtectedRoute] 현재 경로:', location.pathname);
  console.log('[RoleProtectedRoute] 인증 상태:', isAuthenticated);
  console.log('[RoleProtectedRoute] 사용자 역할:', userRole);
  console.log('[RoleProtectedRoute] 요구된 역할들:', requiredRoles);

  useEffect(() => {
    if (location.pathname === '/login') {
      // 로그인 페이지는 체크 안 함
      return;
    }

    if (!isAuthenticated && !alertShown) {
      alert('로그인이 필요합니다');
      console.log('[RoleProtectedRoute] 인증되지 않은 사용자 - 로그인 필요 alert');
      setAlertShown(true);
    }

    if (isAuthenticated && requiredRoles && !requiredRoles.includes(userRole) && !alertShown) {
      alert('권한이 부족합니다');
      console.log('[RoleProtectedRoute] 권한 부족 alert');
      setAlertShown(true);
    }
  }, [isAuthenticated, userRole, requiredRoles, alertShown, location.pathname]);

  // 로그인 페이지라면 RoleProtectedRoute 기능 수행하지 않고 그냥 element 렌더링
  if (location.pathname === '/login') {
    console.log('[RoleProtectedRoute] 로그인 페이지이므로 권한 체크 생략');
    return element;
  }

  if (!isAuthenticated) {
    console.log('[RoleProtectedRoute] 인증 안 됨 - 로그인 페이지로 이동');
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && !requiredRoles.includes(userRole)) {
    console.log('[RoleProtectedRoute] 권한 없음 - 홈 페이지로 이동');
    return <Navigate to="/" replace />;
  }

  console.log('[RoleProtectedRoute] 권한 일치 - 컴포넌트 렌더링');
  return element;
};

export default RoleProtectedRoute;
